import { Chip, TableCell, TableRow, Tooltip } from '@mui/material';
import { FC, useContext } from 'react';
import { Instance, OrderlySystem } from '../../../app/services/api/orderManagementClient';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../../components/shared/useUser';

type Props = {
  item: Instance;
};

const InstanceItemRow: FC<Props> = ({ item }) => {
  const { t } = useTranslation('instances');
  const navigate = useNavigate();
  const { hasPermissionTo } = useContext(UserContext);

  const canEdit = hasPermissionTo(['ConfigurationAdmin']) || hasPermissionTo(['InstanceUpdate']);

  const getSystemName = (system: OrderlySystem): string => {
    switch (system) {
      case OrderlySystem.OFS:
        return 'OFS';
      case OrderlySystem.OFD:
        return 'OFD';
      default:
        return 'Unknown';
    }
  };

  const handleRowClick = () => {
    if (!canEdit) return;
    navigate(`/instances/edit/${item.id}`);
  };

  return (
    <TableRow 
      onClick={canEdit ? handleRowClick : undefined}
      sx={{ 
        cursor: canEdit ? 'pointer' : 'default',
        '&:hover': canEdit ? {
          backgroundColor: 'action.hover',
        } : undefined,
      }}
    >
      <TableCell>
        <Tooltip title={item.name || ''}>
          <span style={{ 
            display: 'block',
            maxWidth: '200px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}>
            {item.name}
          </span>
        </Tooltip>
      </TableCell>
      <TableCell>
        {item.id}
      </TableCell>
      <TableCell align='center'>
        <Chip
          label={getSystemName(item.configuration?.system || OrderlySystem.OFS)}
          size="small"
          color={item.configuration?.system === OrderlySystem.OFS ? 'primary' : 'secondary'}
        />
      </TableCell>
      <TableCell align='center'>
        <Chip
          label={item.configuration?.isOrderlySaaS ? t('yes') : t('no')}
          size="small"
          color={item.configuration?.isOrderlySaaS ? 'success' : 'warning'}
        />
      </TableCell>
    </TableRow>
  );
};

export default InstanceItemRow;
